import styled from "styled-components";

export default styled.p`
  margin: 1rem;
  font-size: 8rem;
`;
